import Vue from "vue";
import VueRouter from "vue-router";
import RosterToolRoutes from "@/components/Roster/routes";
import EventBeaconRoutes from "@/components/EventBeacon/routes";
const ShopPageRoutes = resolvePricingRoutes()
import ClubAdminRoutes from "@/components/ClubAdmin/routes";
import ClubImportToolRoutes from "@/components/ClubImportTool/routes";
import ProgramNeedsRoutes from "@/components/ProgramNeeds/routes";
import IntegrationRoutes from "@/components/Integrations/routes";
import clientData from '@/services/clientData';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  routes: [
    EventBeaconRoutes,
    ShopPageRoutes,
    ClubAdminRoutes,
    ClubImportToolRoutes,
    ProgramNeedsRoutes,
    IntegrationRoutes,
    RosterToolRoutes,
  ],
});

router.beforeEach((to, from, next) => {
  // TODO: handle this properly for back and replace
  router.previous = from;
  next();
});

router.afterEach((to, from) => {
  if (!!from && !!from.name && !!window.SrAnalytics) {
    window.SrAnalytics.page(document.title, to.path);
  }
});

function resolvePricingRoutes()
{
  switch (clientData('domain.slug')) {
    case 'imlca':
      return require("@/components/Domains/IMLCA/Pricing/routes").default;
    default:
      return require("@/components/Pricing/routes").default;
  }
}

export default router;
